<template>
  <div class="table_box">
    <el-table
      ref="tableRef"
      :summary-method="getSummaries"
      show-summary
      size="small"
      :data="data"
      border
      style="width:100%"
      :height="max"
      class="tabone_sty"
      @row-dblclick="detailRow"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'17px',height:'40px'}"
    >
      <el-table-column width="40" align="center" fixed="left">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <template v-for="(item,index) in ConfigData">
        <el-table-column v-if="item.Key == 'Number' && item.Show == true" fixed="left" :label="item.Rename" :prop="item.Key" width="200" align="center" :key="index">
          <template slot-scope="scope">
            <el-button @click.native.prevent="detailRow(scope.row)" type="text" size="small">{{scope.row[item.Key]}}</el-button>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.Key !== 'Number' && item.Show == true" :label="item.Rename" :prop="item.Key" align="center" :key="index">
          <template slot-scope="scope">
            <span  class="span_inner_sty">{{scope.row[item.Key]}}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- table表格配置弹出框 -->
    <TableConfigDialog :show.sync="tableConfigShow" :tableData="ConfigData" v-bind="$attrs" v-on="$listeners" @restoreDefault="restoreDefault" />
  </div>
</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";

export default {
  data() {
    return {
      value: false, //是否启用扫码枪录入商品
      tableConfigShow: false, //配置项弹出框是否显示
      ConfigData: this.tableConfigData, //table配置项数据
      rowIndex: -1, //点击的是第几行
      data:this.tableData,//表格数据项
      searchData: { title: "", data: {}, type: "" }, //传递给选择单价与单位的弹出框,title:弹出框标题、data：传过去的数据、type：类型（单价选择、单位选择）
      pageList:[...dataConfig.pageList],
    };
  },
  props: {
    max: String,
    tableData: Array,
    tableConfigData: Array, //table配置项数据
  },
  methods: {
     // 点击订单编号、双击某一行
    detailRow(data){
      // type：表示从哪个页面跳转过去的
       let item = {
            title: this.findOrderName(data.VchType).pageName,
            component: this.findOrderName(data.VchType).pageRoute,
            menuId: 'goodsDeil' + 'detailRow' + this.findOrderName(data.VchType).pageRoute + Math.random(),
            query:{}
          };
        this.$tab.push(item, {VchCode: data.VchCode,VchType:data.VchType,type:data.Draft,dist:1});
    },
    // 聚焦选中input全部
    inputFocus() {
      event.currentTarget.select();
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // console.log(columns,param);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map(item => {
              if(this.$attrs.pargam.Model=='ReceiveMoney'||this.$attrs.pargam.Model=='PayMoney'){
                if( column.property == "Total"||//收付款款单 金额
                    column.property == "UnJsTotal"||//收付款款单 余额
                    column.property == "ThisTotal"//收付款款单 本次结算金额
                ){
                  return Number(item[column.property])
                }
              }else{
                return this.$attrs.footerMet[column.property];
              }
        });
        if (!values.every(value => isNaN(value))) {
          if(this.$attrs.pargam.Model=='ReceiveMoney'||this.$attrs.pargam.Model=='PayMoney'){
            sums[index] = this.sum(values);
          }else{
            sums[index] = this.$attrs.footerMet[column.property];
          }
          sums[index] += "";
        } else {
          // sums[index] = 'N/A';
        }
      });
      return sums;
    },
    // 累加数组中的number
    sum(arr) {
        var s = 0;
        for (var i=arr.length-1; i>=0; i--) {
            s += arr[i];
        }
        return Number(s).toFixed(2);
    },
    //点击图标事件
    clickIcon() {
      this.tableConfigShow = true;
    },
    // 通过单据类型找到单据名称 nameType:route:路由名字 ，name：单据名称
    findOrderName(val){
      let pageInfor = this.pageList.find(item=>{
        return item.VchType == val
      })
      return pageInfor
    },
    // 恢复默认回调数据
    restoreDefault(data){
      this.ConfigData = data;
    },
  },
  watch: {
    tableConfigData: {
      handler(newValue, oldValue) {
        // console.log('表格配置项数据变化')
        this.ConfigData = newValue;
        this.data = this.tableData;
      },
      deep: true
    },
    tableData:{
      handler(newValue, oldValue) {
        // console.log(newValue,oldValue)
        this.data = this.tableData;
      },
      deep: true
    },
  },
  computed: {},
  mounted() {
    
  }
};
</script>
<style lang="less">
// 引入样式
@import "./GoodsDetailTableRead.less";
</style>


// WEBPACK FOOTER //
// src/components/Table/GoodsDetailTableRead/GoodsDetailTableRead.vue